import type { BoggleRunLedgerEntry } from '~/boggle/engine/standard/types'

export type BoggleBadgeCheck = (
  ledger: readonly BoggleRunLedgerEntry[],
  index: number,
) => boolean

export function isAcceptedWordEntry(
  entry: BoggleRunLedgerEntry | undefined,
): entry is Extract<BoggleRunLedgerEntry, { kind: 'accepted-word' }> {
  return entry?.kind === 'accepted-word'
}

export function isRunEndEntry(
  entry: BoggleRunLedgerEntry | undefined,
): entry is Extract<BoggleRunLedgerEntry, { kind: 'run-end' }> {
  return entry?.kind === 'run-end'
}
